export function getAdvertisement() {
  const promise = new Promise<{
    ifaId: string;
    ifaType: string;
    limitAdTracking: boolean;
  } | null>((resolve) => {
    try {
      const limitAdTracking = webapis?.adinfo?.isLATEnabled();
      const ifaId = webapis?.adinfo?.getTIFA();
      const ifaType = 'tifa';
      resolve({ ifaId, ifaType, limitAdTracking });
    } catch (e) {
      console.error('Could not fetch TIFA data');
      resolve(null);
    }
  });
  return promise;
}

export function getVersion() {
  let version = -1;
  try {
    const tizenVer = navigator.userAgent.match(
      /Tizen \d{0,9}\.\d{0,9}\.\d{0,9}|Tizen \d{0,9}\.\d{0,9}/
    );
    if (tizenVer?.length) {
      version = parseFloat(`${tizenVer[0].replace('Tizen ', '')}`);
    }
  } catch (e) {
    console.error('Error getting Samsung platform', e);
  }
  return version;
}
